import { watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { type ModalV2, useModalStore } from './modal-store';

export function useModalRoute<TProps>(
  queryKey: string,
  modalConfig: (
    itemId: string,
  ) => Omit<
    ModalV2<Omit<TProps, 'resolve' | 'id' | 'isOpen'>>,
    'id' | 'isOpen'
  >,
) {
  const route = useRoute();
  const router = useRouter();
  const modalStore = useModalStore();
  let isOpen = false;

  const closeUrl = () =>
    router.push({ query: { ...route.query, [queryKey]: undefined } });

  watch(
    () => route.query[queryKey] as string | undefined,
    async (itemId) => {
      if (itemId && !isOpen) {
        isOpen = true;
        try {
          await modalStore.openModal(modalConfig(itemId));
        } finally {
          isOpen = false;
          await closeUrl();
        }
      } else if (!itemId && isOpen) {
        modalStore.closeAllModals();
        isOpen = false;
      }
    },
    { immediate: true },
  );

  const open = (id: string) =>
    router.push({ query: { ...route.query, [queryKey]: id } });

  return { open };
}
